import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useFetch } from '../../../../components/hooks/useFetch';
import { Prefix } from '../../../../services/prefix';
import api from '../../../../services/api';
import { CardTracks, ButtonRange } from './EditMonitoringTracksStyle';

const EditMonitoringTracks = ({ idContractItem, HandleRange, sensor }) => {
  const [defaultTracks, setDefaultTracks] = useState([]);
  const [errors, setErrors] = useState([]);

  const listTracks = useFetch(
    Prefix.replace(/[\\"]/g, '') + '/monitor-profile-attributes?id=' + sensor
  );

  useEffect(() => {
    if (listTracks.data?.models?.data) {
      const tracks = listTracks.data.models.data.map((map) => ({
        id: map.id,
        max: parseFloat(map.max),
        min: parseFloat(map.min),
        safety_margin: parseFloat(map.safety_margin),
        id_profile_attribute: map.id_profile_attribute,
        original: {
          min: parseFloat(map.profile_attribute.min),
          max: parseFloat(map.profile_attribute.max),
          safety_margin: parseFloat(map.profile_attribute.safety_margin)
        }
      }));
      setDefaultTracks(tracks);
      setErrors(tracks.map(() => ({ min: false, max: false, safety_margin: false })));
    }
  }, [listTracks.data]);

  const validateField = (track) => {
    const minError = track.min < track.original.min || track.min > track.original.max;
    const maxError = track.max < track.original.min || track.max > track.original.max;
    return { min: minError, max: maxError };
  };

  const handleInputChange = (id, field, value) => {
    let newValue = parseFloat(value);
    if (isNaN(newValue)) newValue = 0;

    setDefaultTracks((prev) =>
      prev.map((track, index) => (index === id ? { ...track, [field]: newValue } : track))
    );
  };

  useEffect(() => {
    if (defaultTracks.length) {
      const newErrors = defaultTracks.map((track) => validateField(track));
      setErrors(newErrors);
    }
  }, [defaultTracks]);

  const handleUpdate = async () => {
    try {
      await Promise.all(
        defaultTracks.map((track) =>
          api.put(
            `${Prefix.replace(/[\\"]/g, '')}/monitor-profile-attributes/${track.id}`,
            {
              max: track.max,
              min: track.min,
              safety_margin: track.safety_margin,
              id_profile_attribute: track.id_profile_attribute
            }
          )
        )
      );
      Swal.fire({
        icon: 'success',
        title: 'Uow...',
        text: 'Suas alterações foram realizadas com sucesso!',
        confirmButtonText: 'Fechar'
      }).then(() => {
        listTracks.mutate();
        HandleRange();
      });
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Houve um problema com a alteração! Por favor tente novamente mais tarde.',
        confirmButtonText: 'Fechar'
      });
    }
  };

  const isDisabled = errors.some((err) => err.min || err.max || err.safety_margin);

  return (
    <div className="customerStep">
      <form>
        {defaultTracks.map((track, key) => (
          <Row key={track.id}>
            <Col>
              <CardTracks>
                <h3 className="text-center">
                  Faixa de {listTracks.data.models.data[key].profile_attribute.unit_of_measure.measure.name}
                </h3>
                <Row>
                  <Col>
                    <label>Mínima</label>
                    <input
                      type="number"
                      className={`form-control ${errors[key]?.min ? 'invalid' : ''}`}
                      value={track.min}
                      onChange={(e) => handleInputChange(key, 'min', e.target.value)}
                    />
                    {errors[key]?.min && (
                      <small style={{ color: 'red' }}>
                        Valor deve estar entre {track.original.min} e {track.original.max}
                      </small>
                    )}
                  </Col>
                  <Col>
                    <label>Máxima</label>
                    <input
                      type="number"
                      className={`form-control ${errors[key]?.max ? 'invalid' : ''}`}
                      value={track.max}
                      onChange={(e) => handleInputChange(key, 'max', e.target.value)}
                    />
                    {errors[key]?.max && (
                      <small style={{ color: 'red' }}>
                        Valor deve estar entre {track.original.min} e {track.original.max}
                      </small>
                    )}
                  </Col>
                  <Col>
                    <label>Margem segura</label>
                    <input
                      type="number"
                      className={`form-control ${errors[key]?.safety_margin ? 'invalid' : ''}`}
                      step={0.25}
                      value={track.safety_margin}
                      onChange={(e) => handleInputChange(key, 'safety_margin', e.target.value)}
                    />
                  </Col>
                </Row>
              </CardTracks>
            </Col>
          </Row>
        ))}

        <Row>
          <Col className="d-flex justify-content-center mt-4">
            <ButtonRange
              type="button"
              onClick={handleUpdate}
              disabled={isDisabled}
              className={isDisabled ? 'disabled-btn' : ''}
            >
              Atualizar
            </ButtonRange>
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default EditMonitoringTracks;